import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div style={{
      minHeight: '100vh',
      padding: '2.5rem 1.5rem',
      backgroundColor: '#0b0b0b',
      color: '#f5f5f5',
      lineHeight: 1.6,
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    }}>
      <main style={{
        maxWidth: '840px',
        margin: '0 auto',
        background: '#151515',
        borderRadius: '16px',
        padding: '2.5rem',
        border: '1px solid #1f1f1f',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.45)'
      }}>
        <h1 style={{ color: '#ff9500', fontWeight: 600, marginTop: 0 }}>Terms of Use</h1>
        <p><strong>Last updated:</strong> January 2025</p>

        <p>Welcome to Ember. These terms govern access to and use of <em>https://ember-app.online</em> and the Ember mobile/desktop experiences ("Ember"). By creating an Ember account you agree to these terms.</p>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Eligibility</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Ember is only for adults who are of legal smoking age where they live.</li>
          <li>You must provide accurate information during sign-up and keep your credentials secure.</li>
        </ul>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Your Use of Ember</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Ember is provided for lawful personal use. Do not upload illegal content, infringe intellectual property, harass others, or attempt to gain unauthorized access.</li>
          <li>You are responsible for the content you post (cellar entries, check-ins, photos, etc.). Make sure you have rights to any media you upload.</li>
          <li>We may modify or discontinue Ember at any time as this is a private beta.</li>
        </ul>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Privacy</h2>
        <p>Please review our <Link to="/privacy" style={{ color: '#d3de5e' }}>Privacy Policy</Link> to understand how we collect, use, and protect your information. Ember relies on Supabase for authentication, database, and storage services.</p>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Intellectual Property</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li>Ember, its logos, branding, and software are owned by Virgil Cain. All rights reserved.</li>
          <li>Do not copy, redistribute, reverse engineer, or resell Ember software or assets.</li>
        </ul>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Termination</h2>
        <p>We reserve the right to suspend or terminate accounts that violate these terms or jeopardize the safety of the Ember community.</p>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Disclaimer</h2>
        <p>Ember is provided "as is" without warranties of any kind. We disclaim liability for indirect, incidental, or consequential damages arising from your use of Ember.</p>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Changes</h2>
        <p>We may update these Terms of Use from time to time. Continued use of Ember after changes constitutes acceptance of the revised terms.</p>

        <h2 style={{ color: '#ff9500', fontWeight: 600 }}>Contact</h2>
        <p>Questions about these terms? Email <a href="mailto:support@ember-app.online" style={{ color: '#d3de5e' }}>support@ember-app.online</a>.</p>
      </main>
    </div>
  );
}

